module.exports = __webpack_public_path__ + "img/studium.e0453214.jpg";